import CMSCard from '../CMSCard/CMSCard';
import DownloadApp from '../DownloadApp/DownloadApp';
import Categories from '../Sidebar/GenericCategories';
import LatestNews from '../Sidebar/LatestNews';
import Newsletter from '../Sidebar/Newsletter';

import styles from './SidebarCMS.module.scss';

function SidebarCMS({ categories, contentName, categoryTitle, appLinks, isSingleNews = false }) {
  return (
    <div className={styles.sidebar}>
      <Categories categories={categories} contentName={contentName} categoryTitle={categoryTitle} />
      {process.env.hasNewsletter && <Newsletter />}
      {contentName !== 'news' && process.env.hasApps && (
        <CMSCard>
          <DownloadApp appLinks={appLinks}>
            <p className={styles.downloadAppTitle}>ΚΑΤΕΒΑΣΕ ΤΟ APP</p>
          </DownloadApp>
        </CMSCard>
      )}
      {isSingleNews && contentName === 'news' && <LatestNews />}
    </div>
  );
}

export default SidebarCMS;
